module.exports = __webpack_public_path__ + "static/media/TenantBuyer3.97ca6bd3.jpg";